const inviteInternal = `
mutation inviteInternal($clientId: String! $inviteInternalInput: inviteInternalInput!){
  inviteInternal(clientId: $clientId inviteInternalInput: $inviteInternalInput){
    id
  }
}
`

const createInternal = `
mutation createInternal($createInternalInput:createInternalInput!){
  createInternal(createInternalInput: $createInternalInput){
    status
    errors
    createdStatus{
      id
    }
  }
}
`

const createOrganization = `
mutation createOrganization($createOrganizationInput:createOrganizationInput!){
  createOrganization(createOrganizationInput: $createOrganizationInput){
    status
    errors
    createdStatus{
      id
    }
  }
}
`

const updateOrganization = `
mutation updateOrganization($id: String! $updateOrganizationInput:updateOrganizationInput!){
  updateOrganization(id: $id updateOrganizationInput: $updateOrganizationInput){
    status
    errors
  }
}
`

const assignRole = `
mutation assignRoleToLogin($loginId: String! $permissionGroupId: String!) {
  addToPermissionGroup(
    loginId: $loginId
    permissionGroupId: $permissionGroupId
  ) {
    errors
    status
  }
}
`
const removeRole = `
mutation removeRole($loginId: String! $permissionGroupId: String!) {
  removeFromPermissionGroup(
    loginId: $loginId
    permissionGroupId: $permissionGroupId
  ) {
    errors
    status
  }
}
`

const readAllLogins = `
query logins($skip: Int, $limit: Int, $sort: sortInput, $userTypes: [userEnumeration]){
  logins(skip: $skip, limit: $limit, sort: $sort, userTypes: $userTypes){
    totalCount
    list{
      id
      permissionGroups{
        name
      }
      associatedUser{
        id
        name
        internalCode
      }
      email
      isEmailConfirmed
      lockoutEndDateUtc
      createdAt
    }
  }
}
`

const readAllInternals = `
query readAllInternals($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      createdAt
      name
      internalCode
      isActive
    }
  }
}
`

const internal = `
query internal($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      createdAt
      name
      englishFirstName
      englishLastName
      chineseFirstName
      chineseLastName
      internalCode
      isActive
      associatedLogin{
        id
        permissionGroups{
          id
          name
        }
      }
    }
  }
}
`

const readAll = `
query readAll($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      createdAt
      createdBy{ associatedUser { id name } }
      lastModifiedAt
      lastModifiedBy{ associatedUser { id name } }
      name
      internalCode
      isActive
      englishFirstName
      englishLastName
    }
  }
  logins{
    list{
      id
      associatedUser{
        id
      }
      username
      isEmailConfirmed
    }
  }
}
`

const readAllOrganizations = `
query readAllOrganizations($where: organizationWhereInput $types: [String] ){
  organizations(where: $where){
    list{
      id
      name
      relationshipList(types: $types){
        list{
          entity{
            id
            name
            ...on internal{
              associatedLogin{
                id
              }
            }
          }
          type
        }
      }
    }
  }
}
`

const deletePermissionGroup = `
  mutation deletePermissionGroup($id: String!) {
    deletePermissionGroup(id: $id) {
      status
      errors
      errors_2 {
        code
        message
      }
    }
  }
`

const organizationsWithLogins = `
query organizationsWithLogins($where: organizationWhereInput $types: [String] ){
  organizations(where: $where){
    list{
      id
      name
      relationshipList(types: $types){
        list{
          entity{
            id
            name
            ...on internal{
              associatedLogin{
                id
              }
            }
          }
          type
        }
      }
    }
  }
}
`

const addInheritedLoginToLogin = `
mutation addInheritedLoginToLogin($loginId: String! $loginIdToInheritFrom: String!){
  addInheritedLoginToLogin(loginId:$loginId loginIdToInheritFrom: $loginIdToInheritFrom){
    status
    errors
  }
}
`

const removeInheritedLoginFromLogin = `
mutation removeInheritedLoginFromLogin($loginId: String! $loginIdToStopInheritFrom: String!){
  removeInheritedLoginFromLogin(loginId:$loginId loginIdToStopInheritFrom: $loginIdToStopInheritFrom){
    status
    errors
  }
}
`

const addLink = `
mutation addLink($linkInput: createLinkInput!){
  addLink(linkInput: $linkInput) {
    status
    errors
  }
}
`

const resendConfirmationEmail = `
mutation resendConfirmationEmail($loginId: String! $clientId: String!){
  resendConfirmationEmail(loginId: $loginId clientId: $clientId){
    status
    errors
  }
}
`

const createLogin = `
mutation createLogin($createLoginInput: createLoginInput!){
  createLogin(createLoginInput: $createLoginInput) {
    status
    errors
    createdStatus{
      id
    }
  }
}
`

const updateInternal = `
mutation updateInternal($id:String! $updateInternalInput:updateInternalInput!){
  updateInternal(id:$id updateInternalInput:$updateInternalInput){
    status
    errors
  }
}
`

const deleteOrganization = `
mutation deleteOrganization($id:String!){
  deleteEntity(id:$id){
    errors
    status
  }
}
`

const removeLink = `
mutation removeLink($linkInput: removeLinkInput!){
  removeLink(linkInput: $linkInput) {
    status
    errors
  }
}
`

const readAllPermissions = `
query readAllPermissions{
  permissions{
    id
    name
    description
  }
}
`

const readAllPermissionGroups = `
query readAllPermissionGroups{
  permissionGroups{
    id
    name
    description
    createdAt
    targettedPermissions{
      permission{
        id
        name
      }
      targetIds
    }
  }
}
`

const createPermissionGroup = `
mutation createPermissionGroup($createPermissionGroupInput: createPermissionGroupInput!){
  createPermissionGroup(createPermissionGroupInput:$createPermissionGroupInput){
		status
    errors
  }
}
`

const addPermissionToPermissionGroup = `
mutation addPermissionToPermissionGroup($id: String! $permissionId: String! $targetId: String!) {
  addPermissionToPermissionGroup(id: $id permissionId: $permissionId targetId: $targetId) {
    status
    errors
  }
}
`

const removePermissionFromPermissionGroup = `
mutation removePermissionFromPermissionGroup($id: String! $permissionId: String! $targetId: String!) {
  removePermissionFromPermissionGroup(id: $id permissionId: $permissionId targetId: $targetId) {
    status
    errors
  }
}
`

const updateLoginLockoutEndDate = `
mutation updateLoginLockoutEndDate($loginId: String!, $dateTime: DateTimeOffset!){
  updateLoginLockoutEndDate(loginId: $loginId, dateTime: $dateTime) {
    status
    errors
    errors_2 {
      code
      message
    }
  }
}
`

const deleteLogin = `
mutation deleteLogin($loginId: String!){
  deleteLogin(loginId: $loginId){
    status
    errors
  }
}
`

const query = {
  readAll,
  readAllLogins,
  readAllInternals,
  internal,
  readAllOrganizations,
  organizationsWithLogins,
  readAllPermissions,
  readAllPermissionGroups
}

const mutation = {
  createInternal,
  createOrganization,
  createLogin,
  updateLoginLockoutEndDate,
  deleteLogin,
  updateOrganization,
  inviteInternal,
  assignRole,
  removeRole,
  resendConfirmationEmail,
  updateInternal,
  addLink,
  deleteOrganization,
  removeLink,
  createPermissionGroup,
  addPermissionToPermissionGroup,
  removePermissionFromPermissionGroup,
  addInheritedLoginToLogin,
  removeInheritedLoginFromLogin,
  deletePermissionGroup
}

export { query, mutation }
